import { React, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import MemberShipHistoryInfoButtonImagePath from '../../../image/MemberShipHistoryInfoButton.png';
import MemberShipHistoryInfoWhiteGrayButtonImagePath from '../../../image/MemberShipHistoryInfoWhiteGrayButton.png';
import MemberShipHistoryInfoWhiteButtonImagePath from '../../../image/MemberShipHistoryInfoWhiteButton2.png';
// import MemberShipHistoryInfoGrayButtonImagePath from '../../../image/MemberShipHistoryInfoGrayButton.png';
// import OrangeTrashIcon from '../../../image/OrangeTrashIcon.png';

export default function PointHistoryInfo(props) {
  const {
    data,
    index,
    size,
    onClickModify,
    onClickDelete
  } = props;

  const [isClicked, setIsClicked] = useState(false);
  const [buttonImage, setButtonImage] = useState(MemberShipHistoryInfoButtonImagePath);
  const [border, setBorder] = useState('1px solid #FFFFFF');
  const [hoverBorder, setHoverBorder] = useState('1px solid #FFFFFF');
  const [backgroundColor, setBackgroundColor] = useState('#FFFFFF');

  const OptionBoxRef = useRef();
  const OptionButtonRef = useRef();
  const OptionEditRef = useRef();
  const OptionHoldRef = useRef();
  const OptionExtendRef = useRef();
  const OptionDeleteRef = useRef();

  useEffect(() => {
    if (data.isExpectedMemberShip) return;

    if (isClicked) {
      OptionBoxRef.current.style.height = `76px`;
      OptionBoxRef.current.style.border = `1px solid #FF8B48`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid #FF8B48`;
    }
  }, [isClicked, data])

  // 마우스 이벤트 핸들러 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 색상 결정 //
  useEffect(() => {
    if (data.point > 0) {
      setBorder('1px solid #FFFFFF');
      setHoverBorder('1px solid #FFFFFF');
      setBackgroundColor('#FFFFFF');
      setButtonImage(MemberShipHistoryInfoWhiteGrayButtonImagePath);
    }
    else {
      setBorder('1px solid #E1E1E1');
      setHoverBorder('1px solid #E1E1E1');
      setBackgroundColor('#E1E1E1');
      setButtonImage(MemberShipHistoryInfoWhiteButtonImagePath);
    }
  }, [data])

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionEditRef.current !== e.target
      && OptionHoldRef.current !== e.target
      && OptionExtendRef.current !== e.target
      && OptionDeleteRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  // 마우스 호버링
  function mouseOver() {
    OptionButtonRef.current.style.opacity = 1;
  }

  // 마우스 호버링
  function mouseLeave() {
    OptionButtonRef.current.style.opacity = 0;
  }

  // 몸체 눌렀을때 켜지기 //
  function onClickBody(e) {
    if (e.target === OptionButtonRef.current || OptionBoxRef.current.contains(e.target)) return;

    onClickModify(data);
  }

  // 포인트 표출 //
  function decidePointView() {
    if (data.point > 0) return '+ ' + data.point.toLocaleString('ko-KR');
    else return '- ' + (data.point * -1).toLocaleString('ko-KR')
  }

  return (
    <TopLevelWrapper>
      <MemberShipComponent
        zIndex={60 + size - index}
        border={border}
        hoverBorder={hoverBorder}
        backgroundColor={backgroundColor}
        onMouseOver={mouseOver}
        onMouseLeave={mouseLeave}
        onClick={onClickBody}>
        <Table>
          <Body>
            <Tr style={{ width: '336px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '326px' }}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='pointer'>{data.reason}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '460px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '450px' }}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='pointer'> {moment(data.approvalDate).format('YY.MM.DD')}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '148px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '138px' }}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='pointer'>{decidePointView()}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <OptionButton ref={OptionButtonRef} src={buttonImage} onClick={() => setIsClicked(!isClicked)} />
                <OptionWrapper ref={OptionBoxRef}>
                  <Option ref={OptionEditRef} onMouseDown={() => onClickModify(data)}>수정</Option>
                  <Option ref={OptionDeleteRef} onMouseDown={() => onClickDelete(data)}>삭제</Option>
                </OptionWrapper>
              </Td>
            </Tr>
          </Body>
        </Table>
      </MemberShipComponent>
    </TopLevelWrapper>
  )
};

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;
`;

const MemberShipComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 1018px;
  height: 50px;

  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  box-shadow: 0px 10px 50px rgba(240, 232, 227, 0.5);

  z-index: ${props => props.zIndex};

  border: ${props => props.border};
  border-radius: 30px;
  background-color: ${props => props.backgroundColor};
    
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    border: ${props => props.hoverBorder};
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
    
  margin-left: 28px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;

const OptionButton = styled.img`
  width: 20px;
  height: 20px;

  opacity: 0;
  // opacity: 1;
    
  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;
    
  z-index: 10;

  margin-top: 40px;
  margin-left: -20px;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 58px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF8B48;
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color: #FF8B48;
  }
`;

const ExpertComponentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: ${props => props.zIndex};
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  opacity: 0;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
`;